import { LoginPayload, LoginResponse, AuthStatusResponse } from '@/types/authentication';
import { GET, POST } from './requests';

export const login = async (payload: LoginPayload): Promise<LoginResponse> => {
  return (await POST<LoginPayload>('/users/auth/login/', payload)).data;
};

export const logout = async (): Promise<{ message: string }> => {
  try {
    return (await POST('/users/auth/logout/', {})).data;
  } catch (error) {
    console.error('Logout error:', error);
    throw error;
  }
};

export const getAuthStatus = async (): Promise<AuthStatusResponse> => {
  return (await GET('/users/auth/status/')).data;
};

export const getLoginRedirect = async (): Promise<{ redirect_url: string; user: any }> => {
  return (await GET('/users/auth/login-redirect/')).data;
};

